/**
 * Copyright (C) 2026 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Box, Button } from '@mui/material';
import React, { useCallback } from 'react';
import { TerminalDetails } from '../../../../../shared/entities/terminal';
import appTheme from '../../../../common/theme/appTheme.json';
import MenuItems from '../../../../common/layout/menu/MenuItems';

interface FullVehicleViewButtonProps {
  tailDetailsPanelTerminal: TerminalDetails | undefined;
  history: any;
}

export const FullVehicleViewButton = ({ tailDetailsPanelTerminal, history }: FullVehicleViewButtonProps) => {
  const datapathUuid = tailDetailsPanelTerminal?.datapathUuid;

  const fullVehicleViewButtonClickedHandler = useCallback(() => {
    if (datapathUuid) {
      history.push(`/${MenuItems.transportMonitoring}/${datapathUuid}`);
    }
  }, [datapathUuid, history]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '76px' }}>
      <Button
        color="primary"
        variant="contained"
        sx={{
          width: '230px',
          height: '36px',
          lineHeight: '12px',
          fontSize: '14px',
          borderRadius: '20px',
          textTransform: 'uppercase',
          backgroundColor: '#3ec1be',
          borderColor: '#3ec1be',
          color: appTheme.primaryBackgroundColor,
          ':hover': {
            backgroundColor: '#3ec1be',
          },
        }}
        id="full__tail__view__button__root"
        data-test="full-tail-view--button"
        onClick={fullVehicleViewButtonClickedHandler}
      >
        Full Vehicle View
      </Button>
    </Box>
  );
};
